<template>
    <div>
        <Navbar />
        <PageTitle pageTitle="KIBANX Wallet" pageTagLine="Safe, Secure and Efficient" />
        <YourOwnBank />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import YourOwnBank from '../Wallet/YourOwnBank'
import Footer from '../Layouts/Footer'

export default {
    name: 'WalletPage',
    components: {
        Navbar,
        PageTitle,
        YourOwnBank,
        Footer,
    }
}
</script>